const maintenance = {
  actions: {
    async getUpcomingMaintenance(context, website) {
      return await context.dispatch("getRequest", {
        api: `ext_web/maintenance/upcoming/${website}`,
      });
    },
  },
};

export default maintenance;
